import {gql, useQuery} from '@apollo/client';

export const ezManagePermissionsQuery = gql`
  query ezManagePermissionsQuery {
    ezManagePermissions {
      id
      canAcceptOrRejectOrders
      canEditTemporaryClosures
      canViewDirectEntry
      canViewOrderIndexPage
      canViewPricesOnOrders
      canViewStoreSettingsPage
      hasUnrestrictedAccess
      canEditUserSettings
      canEditLeadTimes
      canCreatePublicApiCredentials
      canViewDeliveryManagement
      canRequestSettingsUpdate
      canManageDemographicData
      canViewReportsIndexPage
    }
  }
`;

export default function WithEzManagePermissions({children}) {
  const {loading, data} = useQuery(ezManagePermissionsQuery, {
    errorPolicy: 'all',
  });
  if (loading) return null;
  return children({ezManagePermissions: data?.ezManagePermissions ?? {}});
}
